import {
    StyleSheet
} from "react-native";
import {
    type TextInputClearLabelConstantType,
    type TextInputTypeConstantType,
    type TextInputType
} from "./type";
import type {
    FieldType
} from "../fieldControl/type";

export const TEXT_INPUT_TYPES: Record<TextInputType, FieldType> = {
    question: "neutral",
    default: "neutral",
    neutral: "neutral",
    success: "success",
    warning: "warning",
    danger: "danger",
    info: "info"
};

export const TEXT_INPUT_SEARCH_KEYBOARD_TYPES: Array<TextInputClearLabelConstantType["keyboardType"]> = [
    "web-search"
];

export const getTextInputType = ({
    type
}: TextInputTypeConstantType): FieldType => {
    return TEXT_INPUT_TYPES[type];
};

export const getTextInputClearLabelKey = ({
    keyboardType,
    inputMode
}: TextInputClearLabelConstantType): keyof NCoreUIKit.Translation => {
    if(inputMode === "search" || TEXT_INPUT_SEARCH_KEYBOARD_TYPES.includes(keyboardType)) {
        return "clear-search";
    }

    return "clear";
};

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        textAlignVertical: "center",
        includeFontPadding: false,
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1
    }
});
export default stylesheet;
